import { useLocale as __useLocale } from "@/context/LocaleContext";
import { useEffect, useState } from "react";
import { useLocale } from "@/context/LocaleContext";
import { getCampaigns } from "@/lib/api";
import { Sparkles } from "lucide-react";

export function AnnouncementBar() {
  const { t: __t } = __useLocale();
  const { t } = useLocale();
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    getCampaigns()
      .then((c) => setCampaign(c.find((x) => x.show_in_bar && x.active !== false) || c.find((x) => x.active !== false) || c[0]))
      .catch(() => {});
  }, []);

  return (
    <div data-testid="announcement-bar" className="bg-shule-goldlight/60 text-shule-coffee">
      <div className="container-shule flex items-center justify-center gap-2 py-2 text-[11px] sm:text-xs tracking-wide font-medium">
        <Sparkles className="w-3.5 h-3.5 text-shule-gold" aria-hidden="true" />
        <span>{t("750 TL üzeri siparişlerde ücretsiz kargo")}</span>
        <span className="hidden sm:inline text-shule-soft">·</span>
        <span className="hidden sm:inline">{__t(campaign ? campaign.title : t("Shule Club üyelerine özel ayrıcalıklar"))}</span>
      </div>
    </div>
  );
}
